import React, { useEffect, useState } from "react";
import { Dropdown, Spinner, Alert } from "react-bootstrap";
import { MultiSelect } from "react-multi-select-component";
import { Link } from "react-router-dom";
import {
  addContent,
  getContents,
  updateContent,
  deleteContent,
} from "../../../FIREBASECONFIG";
import { emojis } from "../bootstrap/alertData";
import { getUserRole } from "../../../APIS";

const BookingPromos = () => {
  const collectionName = "promotions";
  const imagesFolder = "promotions";
  const role=getUserRole();
  const userDetails=JSON.parse(sessionStorage.getItem("userDetails") || "{}")

  const [contentData, setContentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const itemsPerPage = 15;

  /** Alerts */
  const [successMsg, setSuccessMsg] = useState(null);
  const [error, setError] = useState(null);

  /** Form States */
  const [showForm, setShowForm] = useState(false);
  const [hotels, setHotels] = useState([]);
  const [cities, setCities] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [previewImage, setPreviewImage] = useState(null);
  const [file, setFile] = useState(null);

  const dummyAgents = [];

  /** Fetch Promotions */
  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);
      try {
        const data = await getContents(collectionName);
        const Hotels = await getContents("hotels");

        // If hoteladmin → only include their hotel
        const hotelOptions =
          role === "hoteladmin"
            ? Hotels.filter((h) => h.id === userDetails?.hotelId).map((h) => ({
                label: h.name,
                value: h.id,
              }))
            : Hotels.map((h) => ({
                label: h.name,
                value: h.id,
              }));
  
        setHotels(hotelOptions);
        console.log(role,hotelOptions)
  
        // Only fetch/set cities if NOT hoteladmin
        if (role !== "hoteladmin") {
          const Cities = await getContents("cities");
          const cityOptions = Cities.map((c) => ({
            value: c.id,
            label: c.name,
          }));
          setCities(cityOptions);
        }
  
        setContentData(data);
      } catch (error) {
        console.error("Error fetching Promotions", error);
        setError("Failed to load promotions");
      }
      setLoading(false);
    };
  
    fetchContent();
  }, []);

  /** Filter Content */
  const filterContent = contentData.filter((c) => {
    const lower = searchTerm.toLowerCase();
    if (role === "hoteladmin") {
      const hasHotel = (c.hotels || []).some(
        (h) => h.value === userDetails?.hotelId
      );
      if (!hasHotel) return false;
    }
    return (
      c.name?.toLowerCase().includes(lower) ||
      c.code?.toLowerCase().includes(lower) ||
      c.active?.toString().toLowerCase().includes(lower)
    );
  });

  /** Pagination Data */
  const totalPage = Math.ceil(filterContent.length / itemsPerPage);
  const paginatedContent = filterContent.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  /** Handle File Change */
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    if (selectedFile) {
      setPreviewImage(URL.createObjectURL(selectedFile));
    }
  };

  /** Handle Input Change */
  const handleChange = (e) => {
    const { name, type, multiple, options, value } = e.target;

    if (multiple) {
      // collect all selected values
      const selectedValues = Array.from(options)
        .filter((opt) => opt.selected)
        .map((opt) => opt.value);

      setFormData((prev) => ({
        ...prev,
        [name]: selectedValues,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  /** Handle Submit */
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditMode) {
        await updateContent(
          collectionName,
          imagesFolder,
          formData.id,
          { ...formData },
          file
        );
        setSuccessMsg("Promotion updated successfully!");
      } else {
        await addContent(collectionName, imagesFolder, { ...formData }, file);
        setSuccessMsg("Promotion added successfully!");
      }
      setShowForm(false);
      setIsEditMode(false);
      setFormData({});
      setPreviewImage(null);
      setFile(null);

      const data = await getContents(collectionName);
      setContentData(data);
    } catch (err) {
      console.error(err);
      setError("Failed to save promotion");
    }
  };

  /** Handle Delete */
  const handleDelete = async (id) => {
    try {
      await deleteContent(collectionName, id);
      setContentData((prev) => prev.filter((c) => c.id !== id));
      setSuccessMsg("Promotion deleted successfully!");
    } catch (error) {
      console.error("Error deleting content:", error);
      setError("Failed to delete promotion");
    }
  };

  /** Handle Edit */
  const handleEdit = (item) => {
    setFormData({
      ...item,
      hotels: item.hotels || [],
      cities: item.cities || [],
      agents: item.agents || [],
    });
    setIsEditMode(true);
    setShowForm(true);
    setPreviewImage(item.imageUrl || null);
    setFile(null);
  };

  return (
    <div className="col-12">
      {/* Alerts */}
      {successMsg && (
        <Alert variant="success" dismissible onClose={() => setSuccessMsg(null)}>
          {emojis.success} {successMsg}
        </Alert>
      )}
      {error && (
        <Alert variant="danger" dismissible onClose={() => setError(null)}>
          {emojis.warning} {error}
        </Alert>
      )}
      <div className="card">
        {/* Header */}
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="d-flex align-items-center gap-2">Promotions</h4>
          {!showForm && (
            <div className="d-flex align-items-center gap-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search content"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(0);
                }}
              />
              <button
                className="btn btn-secondary btn-md"
                style={{ whiteSpace: "nowrap" }}
                onClick={() => {
                  setShowForm(true);
                  setIsEditMode(false);
                  setFormData({});
                }}
              >
                Add Promotion
              </button>
            </div>
          )}
        </div>

        {/* Body */}
        <div className="card-body">
          {/* Form */}
          {showForm ? (
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Name */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Promotion Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name || ""}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                {/* Code */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Code</label>
                  <input
                    type="text"
                    name="code"
                    value={formData.code || ""}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                {/* Hotels */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Hotels</label>
                  <MultiSelect
                    options={hotels}
                    value={formData.hotels || []}
                    onChange={(selected) => setFormData({ ...formData, hotels: selected })}
                    labelledBy="Select Hotels"
                  />
                </div>

                {/* Cities */}
                {!["hoteladmin"].includes((role || "").toLowerCase()) && (
                <div className="col-md-6 mb-3">
                  <label className="form-label">Cities</label>
                  <MultiSelect
                    options={cities}
                    value={formData.cities || []}
                    onChange={(selected) =>
                      setFormData({ ...formData, cities: selected })
                    }
                    labelledBy="Select Cities"
                  />
                </div>
                )}
                {/* Agents */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Agents</label>
                  <MultiSelect 
                  options={dummyAgents}
                  value={formData.agents || []}
                  labelledBy="Select Agents"
                  onChange={(selected) =>
                    setFormData({ ...formData, agents: selected })
                  }
                  />
                </div>
                {/* Start Date */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Start From</label>
                  <input
                    type="date"
                    name="startDate"
                    value={formData.startDate || ""}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* End Date */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Ends At</label>
                  <input
                    type="date"
                    name="endDate"
                    value={formData.endDate || ""}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* Flat Discount */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Flat Discount</label>
                  <input
                    type="number"
                    name="flatDiscount"
                    value={formData.flatDiscount || ""}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* Discount % */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Discount Percentage</label>
                  <input
                    type="number"
                    name="discountPercentage"
                    value={formData.discountPercentage || ""}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* Active */}
                <div className="col-md-6 mb-3 form-check form-switch">
                  <input
                    type="checkbox"
                    name="active"
                    checked={formData.active || false}
                    onChange={handleChange}
                    className="form-check-input"
                  />
                  <label className="form-check-label">Activate</label>
                </div>

                {/* Image */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Image</label>
                  <input
                    type="file"
                    name="image"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="form-control"
                  />
                  {previewImage && (
                    <img
                      src={previewImage}
                      alt="Preview"
                      className="mt-2"
                      style={{ width: "100px", height: "auto" }}
                    />
                  )}
                </div>

                {/* Buttons */}
                <div className="col-12 d-flex justify-content-end mt-3">
                  <button type="submit" className="btn btn-secondary">
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary ms-2"
                    onClick={() => {
                      setIsEditMode(false);
                      setFormData({});
                      setShowForm(false);
                      setPreviewImage(null);
                      setFile(null);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          ) : (
            <>
              {/* Table */}
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "200px" }}
                >
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped align-middle">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Code</th>
                        <th>Discount %</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedContent.length > 0 ? (
                        paginatedContent.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.code}</td>
                            <td>{item.discountPercentage} %</td>
                            <td>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={item.active}
                                  onChange={() =>
                                    updateContent(collectionName, imagesFolder, item.id, {
                                      active: !item.active,
                                    })
                                  }
                                />
                              </div>
                            </td>
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle variant="link">
                                  &#x2022;&#x2022;&#x2022;
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end">
                                  <Dropdown.Item onClick={() => handleEdit(item)}>
                                    Edit
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => handleDelete(item.id)}
                                  >
                                    Delete
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="text-center">
                          <td colSpan="6">No Promotions found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Pagination */}
              {!loading && filterContent.length > 0 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    Showing{" "}
                    {filterContent.length === 0
                      ? 0
                      : currentPage * itemsPerPage + 1}{" "}
                    to{" "}
                    {Math.min(
                      (currentPage + 1) * itemsPerPage,
                      filterContent.length
                    )}{" "}
                    of {filterContent.length} entries
                  </div>
                  <div>
                    <button
                      className={`btn btn-sm btn-outline-primary me-2 ${currentPage === 0 ? "disabled" : ""
                        }`}
                      onClick={() =>
                        currentPage > 0 && setCurrentPage(currentPage - 1)
                      }
                    >
                      Prev
                    </button>
                    {Array.from({ length: totalPage }, (_, i) => (
                      <button
                        key={i}
                        className={`btn btn-sm border me-1 ${currentPage === i ? "btn-primary text-white" : ""
                          }`}
                        onClick={() => setCurrentPage(i)}
                      >
                        {i + 1}
                      </button>
                    ))}
                    <button
                      className={`btn btn-sm btn-outline-primary ms-2 ${currentPage === totalPage - 1 ? "disabled" : ""
                        }`}
                      onClick={() =>
                        currentPage + 1 < totalPage &&
                        setCurrentPage(currentPage + 1)
                      }
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookingPromos;